export const SPOT_MODELS = {
  gen3: 'Gen 3',
  gen4: 'Gen 4',
}

export const QUECLINK_MODELS = {
  gl320m: 'GL320M',
  gl330mg: 'GL330MG',
}
